import { render, staticRenderFns } from "./VgtPaginationPageInfo.vue?vue&type=template&id=32c5d44c&scoped=true"
import script from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"
export * from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c5d44c",
  null
  
)

export default component.exports